import React from "react";

export default function PostbackEventTypeBtn({name, isSelected, isDisabled, onSelectEventType}) {

    return (
        <button type="button" disabled={isDisabled}
                className={"btn btn-outline-secondary" + (isSelected ? " active" : "")}
                onClick={onSelectEventType}>{name}</button>
    )
}